import React, { useEffect, useState } from "react";
import { Star, Trash2 } from "lucide-react";
import { ODOO, serializeExtrasToDescription } from "./crmV2Helpers";

const field = {
  width: "100%",
  border: "none",
  borderBottom: `1px solid ${ODOO.borderLight}`,
  outline: "none",
  fontSize: 13,
  padding: "6px 0",
  background: "transparent",
  fontFamily: "inherit",
  boxSizing: "border-box",
};

const CrmV2InlineCreateCard = ({ stageId, busy, onAdd, onEdit, onCancel }) => {
  const [form, setForm] = useState({
    partner_name: "",
    name: "",
    email_from: "",
    phone: "",
    expected_revenue: "",
    priority: 0,
  });

  useEffect(() => {
    setForm({
      partner_name: "",
      name: "",
      email_from: "",
      phone: "",
      expected_revenue: "",
      priority: 0,
    });
  }, [stageId]);

  const set = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const buildPayload = () => {
    const extras = {};
    const org = form.partner_name.trim();
    if (org) {
      // champs en plus → extras (persistés via description)
      extras.company_name = org;
      extras.contact_name = org;
    }
    const base = {
      name: form.name.trim() || org || "New Opportunity",
      type: "opportunity",
      company: org || undefined, // API field, pas partner_name
      email_from: form.email_from.trim() || undefined,
      phone: form.phone.trim() || undefined,
      expected_revenue: form.expected_revenue !== "" ? Number(form.expected_revenue) : 0,
      priority: form.priority,
      stage_id: stageId ? parseInt(stageId, 10) : undefined,
    };
    if (Object.keys(extras).length) {
      base.description = serializeExtrasToDescription("", extras);
    }
    // garde partner_name pour compat _isNew hydratation
    if (org) base.partner_name = org;
    return base;
  };

  const handleAdd = (e) => {
    e.preventDefault();
    if (!form.name.trim() && !form.partner_name.trim()) return;
    onAdd(buildPayload());
  };

  return (
    <form
      onSubmit={handleAdd}
      style={{
        background: "#fff",
        border: `1px solid ${ODOO.cardBorder}`,
        borderRadius: 3,
        padding: "10px 12px",
        marginBottom: 8,
        boxShadow: "0 1px 2px rgba(0,0,0,.06)",
      }}
    >
      <input
        autoFocus
        value={form.partner_name}
        onChange={(e) => set("partner_name", e.target.value)}
        placeholder="Organization / Contact"
        style={field}
        disabled={busy}
      />
      <input
        value={form.name}
        onChange={(e) => set("name", e.target.value)}
        placeholder="e.g. Product Pricing"
        style={{ ...field, fontWeight: 600, marginTop: 4 }}
        disabled={busy}
      />
      <input
        type="email"
        value={form.email_from}
        onChange={(e) => set("email_from", e.target.value)}
        placeholder="Email"
        style={{ ...field, marginTop: 4 }}
        disabled={busy}
      />
      <input
        value={form.phone}
        onChange={(e) => set("phone", e.target.value)}
        placeholder="Phone"
        style={{ ...field, marginTop: 4 }}
        disabled={busy}
      />
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 8 }}>
        <span style={{ fontSize: 12, color: ODOO.muted, whiteSpace: "nowrap" }}>FCFA</span>
        <input
          type="number"
          min="0"
          value={form.expected_revenue}
          onChange={(e) => set("expected_revenue", e.target.value)}
          placeholder="0"
          style={{ ...field, borderBottom: "none", flex: 1, padding: "4px 0" }}
          disabled={busy}
        />
        <div style={{ display: "inline-flex", gap: 1 }}>
          {[0, 1, 2].map((i) => (
            <button
              key={i}
              type="button"
              onClick={() => set("priority", form.priority === i + 1 ? i : i + 1)}
              style={{ border: "none", background: "transparent", padding: 0, cursor: "pointer", display: "inline-flex" }}
            >
              <Star
                size={13}
                fill={i < form.priority ? ODOO.star : "none"}
                color={i < form.priority ? ODOO.star : "#ced4da"}
                strokeWidth={1.5}
              />
            </button>
          ))}
        </div>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 12 }}>
        <button
          type="submit"
          disabled={busy || (!form.name.trim() && !form.partner_name.trim())}
          style={{
            background: ODOO.link,
            color: "#fff",
            border: "none",
            borderRadius: 3,
            padding: "6px 14px",
            fontSize: 12,
            fontWeight: 700,
            letterSpacing: "0.04em",
            cursor: busy ? "wait" : "pointer",
            fontFamily: "inherit",
          }}
        >
          {busy ? "…" : "ADD"}
        </button>
        <button
          type="button"
          disabled={busy}
          onClick={() => onEdit?.(buildPayload())}
          title="Ouvre le formulaire complet — les champs organisation/contact iront dans Extra Information (persisté via description)"
          style={{
            background: ODOO.link,
            color: "#fff",
            border: "none",
            borderRadius: 3,
            padding: "6px 14px",
            fontSize: 12,
            fontWeight: 700,
            letterSpacing: "0.04em",
            cursor: "pointer",
            fontFamily: "inherit",
            opacity: 0.85,
          }}
        >
          EDIT
        </button>
        <button
          type="button"
          onClick={onCancel}
          disabled={busy}
          title="Discard"
          style={{
            marginLeft: "auto",
            border: "none",
            background: "transparent",
            color: ODOO.muted,
            cursor: "pointer",
            padding: 4,
            display: "inline-flex",
          }}
        >
          <Trash2 size={15} />
        </button>
      </div>
    </form>
  );
};

export default CrmV2InlineCreateCard;
